import { render, staticRenderFns } from "./PhoneType.vue?vue&type=template&id=c4676dc6&lang=pug&"
import script from "./PhoneType.vue?vue&type=script&lang=js&"
export * from "./PhoneType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports